import React from 'react';
import { Modal } from '@dotone/react-ui-core';

const MarketplaceInvitePreviewModal = ({ data: { subject, html }, ...otherProps }) => (
  <Modal size="xl" footerVariant="close" title={subject} {...otherProps}>
    <iframe srcDoc={html} width="100%" height={640} style={{ border: 'none' }} />
  </Modal>
);

export default MarketplaceInvitePreviewModal;
